import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import Checkbox from 'material-ui/Checkbox';
import { isLeaf, getSelectionVisualState } from '../../../../../utils/treeUtils';

const styles = () => ({
  title: {
    background: '#F4F6F9',
    width: '100%',
    padding: '12px 12px',
    boxSizing: 'border-box',
    textAlign: 'left',
    fontSize: '13px',
    color: '#5A5B62',
    display: 'flex',
    alignItems: 'center',
  },

  item: {
    textAlign: 'left',
    display: 'flex',
    alignItems: 'center',
  },

  text: {
    fontSize: '13px',
    color: '#181819',
    textOverflow: 'ellipsis',
    display: 'inline-block',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    cursor: 'pointer',
  },

  label: {
    fontWeight: 'bold',
    fontSize: '8px',
    background: '#FFC62B',
    color: '#FFFFFF',
    padding: '1px 4px',
    marginLeft: '5px',
    whiteSpace: 'nowrap',
    borderRadius: '3px',
  },
});

const MARGIN_RIGHT_TITLE = 8;
const MARGIN_RIGHT_ITEM = 5;

/**
 * 階層構造のメニューの1行を表示するコンポーネント
 */
class NodeRow extends React.PureComponent {
  render() {
    const { classes, node, selectedItems, onToggle, isTitle, extraStyle, contextData } = this.props;

    const vis = isLeaf(node)
      ? { checked: selectedItems.has(Number(node.id)), indeterminate: false }
      : getSelectionVisualState(node, selectedItems);

    const wrapperClass = isTitle ? classes.title : classes.item;
    

    return (
      <div className={wrapperClass} style={extraStyle || {}}>
        <Checkbox
          color="primary"
          checked={vis.checked}
          indeterminate={vis.indeterminate}
          style={{ width: '15px', height: '15px', marginRight: isTitle ? MARGIN_RIGHT_TITLE : MARGIN_RIGHT_ITEM }}
          value={String(node.id)}
          onChange={() => onToggle(node)}
        />
        <div
          className={classes.text}
          title={String(node.id)}
          style={isTitle ? { color: '#5A5B62' } : null}
          onClick={() => onToggle(node)}
        >
          {node.name || node.id}
        </div>
        {contextData && contextData.shouldShowLabel && contextData.shouldShowLabel(node) && (
          <div className={classes.label}>{contextData.labelText || 'NEW'}</div>
        )}
      </div>
    );
  }
}

NodeRow.propTypes = {
  classes: PropTypes.object.isRequired,
  node: PropTypes.object.isRequired,
  selectedItems: PropTypes.object.isRequired, // Immutable Set
  onToggle: PropTypes.func.isRequired,
  isTitle: PropTypes.bool,
  extraStyle: PropTypes.object,
  contextData: PropTypes.object,
};

export default withStyles(styles)(NodeRow);



// WEBPACK FOOTER //
// ./src/components/ExecutiveList/dialogs/SelectHierarchicalMenuDialog/common/NodeRow.jsx